import { sparkToast } from '@spark';
import {
    deletedTasksToastTitle,
    uniqueTaskNamesFromUsecases,
} from './projectDeletedToast.jsx';

/** User-facing reason when delete is blocked because a task is still deployed. */
export const CANNOT_DELETE_DEPLOYED_TASKS = 'Cannot delete deployed tasks';

export const isDeployedDeleteFailure = (message) =>
    typeof message === 'string' && /deployed/i.test(message);

export const deleteFailureToastTitle = (message, fallback = 'Failed to delete') =>
    isDeployedDeleteFailure(message) ? CANNOT_DELETE_DEPLOYED_TASKS : (message || fallback);

/**
 * Toast copy for bulk task delete. When any failure is a deployed-task block,
 * the reason is "Cannot delete deployed tasks" instead of a generic count.
 */
export const bulkDeleteToast = ({
    deleted = 0,
    failed = 0,
    failures = [],
    usecases = [],
} = {}) => {
    if (failed <= 0) {
        return { type: 'success', title: `Deleted ${deleted} task(s) successfully` };
    }

    const deployedBlocked =
        failures.some((failure) => isDeployedDeleteFailure(failure?.message)) ||
        usecases.some((usecase) => usecase?.is_deployed);

    if (deleted > 0) {
        return {
            type: 'warning',
            title: deployedBlocked
                ? `Deleted ${deleted} task(s). Cannot delete deployed tasks.`
                : `Deleted ${deleted} task(s). Failed to delete ${failed}.`,
        };
    }

    return {
        type: 'error',
        title: deployedBlocked
            ? CANNOT_DELETE_DEPLOYED_TASKS
            : `Failed to delete ${failed} task(s).`,
    };
};

export const showBulkDeleteResultToast = (args) => {
    const { deleted = 0, failed = 0, usecases = [] } = args;
    if (failed <= 0 && deleted > 0) {
        const names = uniqueTaskNamesFromUsecases(usecases);
        sparkToast.success(
            names.length > 0
                ? deletedTasksToastTitle(names)
                : `Deleted ${deleted} task(s) successfully`
        );
        return;
    }
    const { type, title } = bulkDeleteToast(args);
    sparkToast[type](title);
};

export const showDeleteFailureToast = (message, fallback) => {
    sparkToast.error(deleteFailureToastTitle(message, fallback));
};
